import { call, put, takeLatest } from "redux-saga/effects"
import { FETCH_SUPPORT_BADGE, FETCH_MY_SUPPORT_BADGE } from "./actionTypes"
import { fetchSupportBadgeSuccess, fetchMySupportBadgeSuccess, clearSupportBadge } from "./actions"
import { getAdminTicketSummary, getTicketSummary } from "../../api/requests/ticket-requests"

function* fetchSupportBadgeSaga() {
  try {
    const response = yield call(getAdminTicketSummary)
    yield put(fetchSupportBadgeSuccess(response.data))
  } catch (error) {
    // Sessiz geç: menü rozeti kritik değil (yetkisiz kullanıcıda da bu dala düşer).
    yield put(clearSupportBadge())
  }
}

function* fetchMySupportBadgeSaga() {
  try {
    const response = yield call(getTicketSummary)
    yield put(fetchMySupportBadgeSuccess(response.data))
  } catch (error) {
    // Sessiz geç: menü rozeti kritik değil.
    yield put(clearSupportBadge())
  }
}

function* supportBadgeSaga() {
  yield takeLatest(FETCH_SUPPORT_BADGE, fetchSupportBadgeSaga)
  yield takeLatest(FETCH_MY_SUPPORT_BADGE, fetchMySupportBadgeSaga)
}

export default supportBadgeSaga
